import type { Special } from "@/types";

export const specials: Special[] = [
  {
    id: "noir-puzzles",
    title: "暗夜迷局",
    subtitle: "悬疑刑侦片单",
    intro:
      "雨夜、旧案、不肯妥协的追凶者。我们挑选了近年最耐得住反复推敲的悬疑与刑侦作品，它们共同的特点是：真相总在最后一块拼图处翻盘。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20detective%20moodboard%20with%20evidence%20photos%20and%20red%20thread%20on%20a%20board%2C%20deep%20blue%20and%20warm%20orange%20lighting%2C%20mystery%20atmosphere%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-noir-puzzles&orientation=landscape",
    accent: "primary",
    groups: [
      {
        title: "雨夜追凶",
        reason: "同为冷峻色调下的城市犯罪叙事，适合连着看完，气氛一以贯之。",
        workIds: ["shadow-city", "deep-blue-case"],
      },
      {
        title: "旧案与潜伏",
        reason: "一桩跨越时间的旧案与一段深埋敌营的潜伏，同样考验观看时的推理耐心。",
        workIds: ["code-name-orchid", "silent-river"],
      },
    ],
  },
  {
    id: "time-and-stars",
    title: "时间与星空",
    subtitle: "科幻想象特辑",
    intro:
      "当科学遇上情感，时间就变成了一门关于告别的学科。这份片单献给所有仰望过夜空、也害怕过失去的人。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20sci%20fi%20backdrop%20of%20glowing%20concentric%20light%20rings%20and%20scattered%20stars%20in%20deep%20blue%20space%2C%20warm%20amber%20accents%2C%20dreamlike%20atmosphere%2C%20professional%20editorial%20art%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-time-stars&orientation=landscape",
    accent: "accent",
    groups: [
      {
        title: "折叠时间的浪漫",
        reason: "都以轻科幻设定承载最私密的情感，设定克制，情感浓烈。",
        workIds: ["echoes-of-time", "starlight-promise"],
      },
      {
        title: "高能视觉系",
        reason: "霓虹美学与高强度动作，是科幻迷不容错过的视觉盛宴。",
        workIds: ["neon-hunter"],
      },
    ],
  },
  {
    id: "slow-healing",
    title: "慢慢来，会好的",
    subtitle: "治愈系生活特辑",
    intro:
      "没有反转，没有嘶吼，只有一顿饭、一条河、一盏亮着的窗。疲惫的时候，不妨从这份片单里挑一部，慢慢看完。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20serene%20lifestyle%20backdrop%20of%20a%20cozy%20lamp%20lit%20room%20window%20overlooking%20misty%20mountains%2C%20soft%20green%20blue%20and%20warm%20amber%20tones%2C%20peaceful%20calm%20mood%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-slow-healing&orientation=landscape",
    accent: "secondary",
    groups: [
      {
        title: "乡野与故乡",
        reason: "两条关于归途的叙事，把乡愁拍得安静又绵长。",
        workIds: ["silent-river", "mountain-and-sea"],
      },
      {
        title: "城市里的微光",
        reason: "写给每一个在城市里独自打拼、却依然愿意温柔的人。",
        workIds: ["city-lights"],
      },
    ],
  },
  {
    id: "ancient-flame",
    title: "庙堂与烟火",
    subtitle: "古装佳作特辑",
    intro:
      "一边是刀光剑影里的权谋博弈，一边是灶台烟火中的人间滋味。古装题材最迷人的地方，是它既能承载野心，也能安放日常。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20backdrop%20of%20a%20palace%20courtyard%20with%20lanterns%20and%20drifting%20mist%20at%20dusk%2C%20deep%20blue%20and%20warm%20amber%20grading%2C%20epic%20historical%20mood%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-ancient-flame&orientation=landscape",
    accent: "accent",
    groups: [
      {
        title: "权谋与刀锋",
        reason: "缜密的权力推演配合凌厉武打，适合喜欢烧脑与爽感兼具的观众。",
        workIds: ["blade-monarch"],
      },
      {
        title: "美食与温柔",
        reason: "用一道道菜串起的轻喜剧，是沉重故事之外最可口的一次调剂。",
        workIds: ["the-cook-of-tang"],
      },
    ],
  },
  {
    id: "youth-forever",
    title: "青春不散场",
    subtitle: "校园成长特辑",
    intro:
      "关于约定、关于错过、关于重新出发。青春题材之所以常拍常新，是因为每个人都有一段回不去、却总想再走一遍的路。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20backdrop%20of%20a%20school%20rooftop%20under%20a%20starry%20night%20sky%20with%20warm%20string%20lights%2C%20deep%20blue%20and%20amber%20grading%2C%20romantic%20youthful%20mood%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-youth-forever&orientation=landscape",
    accent: "secondary",
    groups: [
      {
        title: "星空下的约定",
        reason: "把等待写成一门浪漫的学问，适合相信“重逢”的人。",
        workIds: ["starlight-promise"],
      },
      {
        title: "长大以后的我们",
        reason: "从校园走向职场，看成长如何悄悄改变一个人。",
        workIds: ["city-lights", "the-last-letter"],
      },
    ],
  },
  {
    id: "home-and-heart",
    title: "家的方向",
    subtitle: "亲情主题特辑",
    intro:
      "我们把镜头对准餐桌、信纸与渡口。这些作品讲述的，都是同一件事——无论走多远，总有一个地方在等你回头。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20heartwarming%20backdrop%20of%20a%20rustic%20Chinese%20home%20with%20a%20warm%20lit%20window%20in%20misty%20mountains%20at%20dusk%2C%20muted%20green%20blue%20and%20amber%20tones%2C%20family%20drama%20mood%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20horizontal%20composition&width=1000&height=700&seq=special-home-heart&orientation=landscape",
    accent: "primary",
    groups: [
      {
        title: "一顿饭的团圆",
        reason: "中国式亲情最动人的表达，往往藏在一桌热气腾腾的饭菜里。",
        workIds: ["mountain-and-sea", "silent-river"],
      },
      {
        title: "说不出口的思念",
        reason: "那些没能寄出的信，构成了关于牵挂最温柔的注脚。",
        workIds: ["the-last-letter"],
      },
    ],
  },
];